export const dateAndTimeToMs = (date: Date, time: string): number => {
  if (!date || !time) {
    console.warn('dateAndTimeToMs: date or time is invalid');
    return null;
  }

  const hoursAndMinutes: Array<string> = time.split(':');
  return date.setHours(Number(hoursAndMinutes[0]), Number(hoursAndMinutes[1]));
};

export const msToDateAndTime = (ms: number): { date: Date; time: string } => {
  const date = new Date(ms);
  return {
    date,
    time: ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
  };
};
